// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3pCMT","title":"AfterFrontImage_title__1gk2c"};